import { Col, ConfigProvider, Form, Row } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";
import Selects from "../../../../biblio/Selects/Selects";
import ar_EG from "antd/lib/locale/ar_EG";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ar";
import HijriFeature from "../../../../biblio/HijriFeature";

dayjs.extend(updateLocale);

dayjs.updateLocale("ar", {
  weekStart: 6,
  weekdays: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
});

interface FatherProps {
  nationality: any;
  deathReasons: any;
  identificationTypes: any;
  form: any;
}

const FatherForm = ({
  nationality,
  deathReasons,
  identificationTypes,
  form,
}: FatherProps) => {
  /* Handle date change */
  const handleDateChange = (field: string) => (dateValue: any) => {
    form.setFieldsValue({
      [field]: dateValue,
    });
  };

  /** find nationality by id */
  const findNationality =
    nationality &&
    nationality?.data?.find(
      (item: any) => item.id === form.getFieldValue(`father_country_id`)?.value
    );

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <div className="takaful--title-tabs-sub">
          <span>معلومات عن الأب</span>
        </div>
        <Row gutter={16}>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_firstname"
              label="الاسم الأول"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_father_name"
              label="إسم الأب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_grandfather_name"
              label="إسم الجد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_family_name"
              label="إسم العائلة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_eng_name"
              label="الاسم بالانجليزية"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_birthday"
              label="تاريخ الميلاد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("father_birthday")}
                maxDateGregorian={dayjs(new Date())}
                maxDateHijri={dayjs(new Date()).toDate()}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_country_id"
              label="الجنسية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={nationality?.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_identification_type_id"
              label="نوع الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={identificationTypes.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_identification_number"
              label="رقم الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  len: 10,
                  message: "يجب أن يتكون رقم الهوية من 10 ارقام",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="tel" maxLength={10} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_identification_source"
              label="مصدر الهوية"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_identification_date"
              label="تاريخ الهوية"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("father_identification_date")}
                maxDateGregorian={dayjs(new Date())}
                maxDateHijri={dayjs(new Date()).toDate()}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="father_identification_deadline"
              label="تاريخ نهاية الهوية"
              rules={[
                {
                  // eslint-disable-next-line eqeqeq
                  required: findNationality?.code != "SA",
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("father_identification_deadline")}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="death_date"
              label="تاريخ الوفاة "
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("death_date")}
                maxDateGregorian={dayjs(new Date())}
                maxDateHijri={dayjs(new Date()).toDate()}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="death_reason_id"
              label="سبب الوفاة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={deathReasons.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="ex_profession"
              label="المهنة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
        </Row>
      </ConfigProvider>
    </>
  );
};

export default FatherForm;
